<template>
  <div class="nullable-checkbox-input">
    <div
      class="form-group"
      :id="id">
      <legend>{{ legend }}</legend>
      <div
        class="form-check form-check-inline"
        v-for="(option, key) in options"
        :key="key">
        <input
          class="form-check-input"
          type="checkbox"
          :name="name"
          v-model="checks[key]"
          @click="singleChecked">
        <label
          class="form-check-label"
          :for="name">{{ option }}</label>
      </div>

      <input
        type="hidden"
        :name="name"
        :value="nullCheck">
    </div>
  </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        legend: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            default: '',
        },
        oldValue: {
            type: Boolean,
            default: null,
        },
    },

    data() {
        return {
            checks: this.options.map((opt) => {
                return opt === this.oldValue;
            }),
        };
    },

    computed: {
        nullCheck: function() {
            if (this.checks.filter(check => check).length === 0) {
                return null;
            }

            return this.options[this.checks.indexOf(true)];
        },
    },

    methods: {
        singleChecked() {
            // this will run before default click action, thus
            // unchecking all checkboxes
            this.checks = this.checks.map(() => false);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/measurements-module/NullableCheckboxInput.vue